import { afterAttack, defineGameCard, heatsUp } from '../authoring/index.js';
export const TitanPrototypeCard = defineGameCard({
    id: 'titan_prototype',
    gameplay: {
        type: 'UNIT', cost: 6,
        baseStats: { attack: 7, health: 6 }, keywords: ['CANNOT_COOL'],
    },
    presentation: {
        name: 'Прототип «Титан»',
        description: 'Греется. Его нельзя охладить. После атаки получает Щит 2.',
        glyph: {
            colors: ['#10213A', '#2F4754', '#647571', '#46616E', '#8E4A2D'],
            rows: [
                '..........1.........',
                '.........121........',
                '....111.12221.......',
                '...123411233111.....',
                '...1233141111121....',
                '....1221335553221...',
                '..12211133555311....',
                '..112111222221121...',
                '.1231..11222111123..',
                '.1223...1111..11211.',
                '.11211.221111..1114.',
                '.12211.22311....112.',
                '..111..121441.......',
                '.......112221.......',
                '......1111241.......',
                '.....11111221.......',
                '.....111.112111.....',
                '......11.11111......',
                '......33.33333......',
                '....................',
            ],
        },
    },
    role: 'playable',
    abilities: [
        afterAttack((ctx) => {
            const self = ctx.self;
            if (self === undefined)
                return;
            ctx.ops.addShield(TitanPrototypeCard.id, self.id, 2, self.id);
        }),
        heatsUp(),
    ],
    ui: { mechanics: ['heats_up', 'heat', 'cannot_cool', 'shield'] },
});
//# sourceMappingURL=titan-prototype.js.map